import { ArrowChangeDown } from 'components/Icons/ArrowChangeDown'
import { ArrowChangeUp } from 'components/Icons/ArrowChangeUp'
import { HeaderCellWrapper, InfoIconContainer } from 'components/Tokens/TokenTable/TokenRow'
import { MouseoverTooltip } from 'components/Tooltip'
import { useAtomValue } from 'jotai/utils'
import { ReactNode } from 'react'
import { Info } from 'react-feather'
import { useTheme } from 'styled-components/macro'

import { sortAscendingAtom, sortMethodAtom, useSetSortMethod, VoteSortMethod } from './state'

const HEADER_DESCRIPTIONS: Record<VoteSortMethod, ReactNode | undefined> = {
  [VoteSortMethod.POOL]: undefined,
  [VoteSortMethod.TVL]: undefined,
  [VoteSortMethod.VAPR]: undefined,
  [VoteSortMethod.FEES]: undefined,
  [VoteSortMethod.BRIBES]: undefined,
  [VoteSortMethod.TOTAL_REWARDS]: undefined,
  [VoteSortMethod.TOTAL_VOTES]: undefined,
  [VoteSortMethod.MY_VOTE]: undefined,
  [VoteSortMethod.EARN]: undefined,
}

export default function HeaderCell({
  category,
  justify,
}: {
  category: VoteSortMethod // TODO: change this to make it work for trans
  justify?: string
}) {
  const theme = useTheme()
  const sortAscending = useAtomValue(sortAscendingAtom)
  const handleSortCategory = useSetSortMethod(category)
  const sortMethod = useAtomValue(sortMethodAtom)

  const description = HEADER_DESCRIPTIONS[category]

  return (
    <HeaderCellWrapper onClick={handleSortCategory} justify={justify}>
      {sortMethod === category && (
        <>
          {sortAscending ? (
            <ArrowChangeUp width={16} height={16} color={theme.textPrimary} />
          ) : (
            <ArrowChangeDown width={16} height={16} color={theme.textSecondary} />
          )}
        </>
      )}
      {category}
      {description && (
        <MouseoverTooltip text={description} placement="right">
          <InfoIconContainer>
            <Info width="16px" height="16px" />
          </InfoIconContainer>
        </MouseoverTooltip>
      )}
    </HeaderCellWrapper>
  )
}
